<template>
    <BootstrapModal
        ref="calendlyEmbedModalRef"
        modalId="calendly-embed-modal"
        modalSize="l"
        :title="data.title || 'Calendly'"
        :closeText="'Close'"
        @close="closeModal"
    >
        <template #left-icon>
            <svg
                @click="showPopup = true"
                width="1.5rem"
                height="1.5rem"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 2.25C14.7051 2.25 13.25 3.70507 13.25 5.5C13.25 5.69591 13.2673 5.88776 13.3006 6.07412L8.56991 9.38558C8.54587 9.4024 8.52312 9.42038 8.50168 9.43939C7.94993 9.00747 7.25503 8.75 6.5 8.75C4.70507 8.75 3.25 10.2051 3.25 12C3.25 13.7949 4.70507 15.25 6.5 15.25C7.25503 15.25 7.94993 14.9925 8.50168 14.5606C8.52312 14.5796 8.54587 14.5976 8.56991 14.6144L13.3006 17.9259C13.2673 18.1122 13.25 18.3041 13.25 18.5C13.25 20.2949 14.7051 21.75 16.5 21.75C18.2949 21.75 19.75 20.2949 19.75 18.5C19.75 16.7051 18.2949 15.25 16.5 15.25C15.4472 15.25 14.5113 15.7506 13.9174 16.5267L9.43806 13.3911C9.63809 12.9694 9.75 12.4978 9.75 12C9.75 11.5022 9.63809 11.0306 9.43806 10.6089L13.9174 7.4733C14.5113 8.24942 15.4472 8.75 16.5 8.75C18.2949 8.75 19.75 7.29493 19.75 5.5C19.75 3.70507 18.2949 2.25 16.5 2.25ZM14.75 5.5C14.75 4.5335 15.5335 3.75 16.5 3.75C17.4665 3.75 18.25 4.5335 18.25 5.5C18.25 6.4665 17.4665 7.25 16.5 7.25C15.5335 7.25 14.75 6.4665 14.75 5.5ZM6.5 10.25C5.5335 10.25 4.75 11.0335 4.75 12C4.75 12.9665 5.5335 13.75 6.5 13.75C7.4665 13.75 8.25 12.9665 8.25 12C8.25 11.0335 7.4665 10.25 6.5 10.25ZM16.5 16.75C15.5335 16.75 14.75 17.5335 14.75 18.5C14.75 19.4665 15.5335 20.25 16.5 20.25C17.4665 20.25 18.25 19.4665 18.25 18.5C18.25 17.5335 17.4665 16.75 16.5 16.75Z"
                        fill="#999"
                    ></path>
                </g>
            </svg>
        </template>

        <template #body>
            <div class="text-center">
                <div class="text-center mb-3">
                    <iframe
                        v-if="show"
                        class="embed-responsive-item"
                        :src="generateCalendlyEmbedUrl(data.url)"
                        width="100%"
                        height="700"
                        frameborder="0"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
        </template>
    </BootstrapModal>

    <SharePopup
        :show="showPopup"
        :username="username"
        :urlName="urlName"
        :shortCode="shortCode"
        @close="showPopup = false"
    />
</template>

<script>
import BootstrapModal from "@/Components/BootstrapModal.vue";
import SharePopup from "@/Components/SharePopup.vue";

export default {
    name: "CalendlyEmbed",
    components: {
        BootstrapModal,
        SharePopup
    },
    props: {
        username: {},
        urlName: '',
        shortCode: '',
    },
    data() {
        return {
            showPopup: false,
            show: false,
            data: {
                type: Object,
                required: true
            },
            shortCode: "",
        };
    },
    methods: {
        showModal(link) {
            this.show = true;
            this.data = link;
            this.shortCode = link.short_code;
            this.$refs.calendlyEmbedModalRef.showModal("calendly-embed-modal");
        },
        closeModal() {
            this.show = false;
            this.$refs.calendlyEmbedModalRef.closeModal("calendly-embed-modal");
        },
        generateCalendlyEmbedUrl(url) {
            if (!url) return null;

            const base = url.replace(/\?.*$/, ''); // remove any existing query params
            const domain = window.location.hostname;

            return `${base}?embed_domain=${domain}&embed_type=Inline&hide_gdpr_banner=1&hide_event_type_details=1`;
        }
    }
};
</script>
